import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'PlanCity';
const DEFAULT_DESCRIPTION = 'Descubre los mejores panoramas, conciertos, festivales, escapadas, ferias y actividades en tu comuna. Tu directorio de eventos locales en Chile.';
export const BASE_URL = 'https://plancity.cl';

// Turns relative paths (/api/static/uploads/..., /panoramas-...jpg) into canonical absolute URLs.
export const absoluteUrl = (u) => {
  if (!u) return u;
  if (/^https?:\/\//i.test(u)) return u;
  return BASE_URL + (u.startsWith('/') ? u : `/${u}`);
};

export const SEO = ({ title, description, path, type = 'website', image, noIndex = false, jsonLd }) => {
  const fullTitle = title ? String(title + ' | ' + SITE_NAME) : String(SITE_NAME + ' - Panoramas, Eventos y Actividades cerca de ti');
  const desc = description || DEFAULT_DESCRIPTION;
  const url = path ? String(BASE_URL + path) : BASE_URL;
  const img = absoluteUrl(image);

  const metaTags = [
    { name: 'description', content: desc },
    { property: 'og:type', content: type },
    { property: 'og:url', content: url },
    { property: 'og:title', content: fullTitle },
    { property: 'og:description', content: desc },
    { property: 'og:site_name', content: SITE_NAME },
    { property: 'og:locale', content: 'es_CL' },
    { name: 'twitter:card', content: img ? 'summary_large_image' : 'summary' },
    { name: 'twitter:title', content: fullTitle },
    { name: 'twitter:description', content: desc },
    { name: 'robots', content: noIndex ? 'noindex, nofollow' : 'index, follow' },
  ];

  if (img) {
    metaTags.push({ property: 'og:image', content: img });
    metaTags.push({ name: 'twitter:image', content: img });
  }

  return (
    <>
      <Helmet
        title={fullTitle}
        meta={metaTags}
        link={[{ rel: 'canonical', href: url }]}
      />
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
};
